/**
 *
 */

import $ from 'jquery';

export default class SearchPanel {

	constructor(options) {
		this.id = options.id;
		this.isActive = false;
		this.init.call(this);
	}

	init() {
		this.panel = document.getElementById(this.id);
	}

	launch() {
		$(this.panel).removeClass(this.id + '--inactive');
		$(this.panel).addClass(this.id + '--active');
		window.uo.events.emit('search-panel--open');
		this.isActive = true;
	}

	hide() {
		$(this.panel).addClass(this.id + '--inactive');
		$(this.panel).removeClass(this.id + '--active');
		window.uo.events.emit('search-panel--close');
		this.isActive = false;
	}

}